/* eslint-disable react/prop-types */
import React from 'react';
import { Card, Row } from 'antd';

/**
 * Tarjeta de sección reutilizable para agrupar campos de formulario por bloques.
 * Neutraliza el alto forzado por `.form-container .ant-card-body` (ver Layout/index.scss)
 * mediante bodyStyle en línea, para evitar el espacio en blanco excesivo entre bloques.
 */
const SectionCard = ({
  id,
  number,
  title,
  description,
  children,
}) => (
  <Card
    id={id}
    style={{ marginBottom: 12, borderRadius: 8, scrollMarginTop: 72 }}
    headStyle={{ background: '#faf7f0', borderRadius: '8px 8px 0 0' }}
    bodyStyle={{
      height: 'auto',
      minHeight: 0,
      overflow: 'visible',
      paddingTop: 16,
      paddingBottom: 4,
    }}
    title={<span style={{ fontWeight: 600 }}>{`${number}. ${title}`}</span>}
    extra={(
      <span style={{ color: '#9b9b9b', fontWeight: 400, fontSize: 13 }}>
        {description}
      </span>
    )}
  >
    <Row gutter={10}>{children}</Row>
  </Card>
);

export default SectionCard;
